import { render, staticRenderFns } from "./FeatureItem.vue?vue&type=template&id=55472e59&"
import script from "./FeatureItem.vue?vue&type=script&setup=true&lang=ts&"
export * from "./FeatureItem.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55472e59')) {
      api.createRecord('55472e59', component.options)
    } else {
      api.reload('55472e59', component.options)
    }
    module.hot.accept("./FeatureItem.vue?vue&type=template&id=55472e59&", function () {
      api.rerender('55472e59', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuFeatures/components/FeatureItem.vue"
export default component.exports